import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { labels } from '../../reducers/labels';

const useLabelsActions = () => {
    const dispatch = useDispatch();

    return bindActionCreators(labels.actions, dispatch);
};

export default useLabelsActions;
